import { render, staticRenderFns } from "./ListKyoaiAddress.vue?vue&type=template&id=6a6ffaf8&scoped=true&"
import script from "./ListKyoaiAddress.vue?vue&type=script&lang=js&"
export * from "./ListKyoaiAddress.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=6a6ffaf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ffaf8",
  null
  
)

export default component.exports